import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { io, Socket } from 'socket.io-client';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class NotificationSocketService {
  private socket: Socket;

  // Subject to broadcast incoming notifications to subscribed components
  private notificationSubject = new Subject<any>();
  public notifications$ = this.notificationSubject.asObservable();

  constructor() {
    const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
    const socketUrl = (environment as any).socketUrl || `${protocol}//${window.location.hostname}:3002`;

    // Initialize socket connection
    this.socket = io(socketUrl, {
      transports: ['websocket', 'polling'],
      autoConnect: false // Connect manually when we have the user info
    });

    // Listen for notification events from the backend
    this.socket.on('notification', (data: any) => {
      this.notificationSubject.next(data);
    });

    this.socket.on('connect', () => {
    });

    this.socket.on('disconnect', () => {
    });
  }

  /**
   * Connect and register the user to join their specific notification room
   */
  public connectAndRegister(userId: string | number, b_acct_id?: number) {
    if (this.socket.disconnected) {
      this.socket.connect();
    }

    // Send register event so backend adds us to user_{userId} room
    if (userId) {
      this.socket.emit('register', { userId, b_acct_id });
    }
  }

  public disconnect() {
    if (this.socket.connected) {
      this.socket.disconnect();
    }
  }

  public emitNotification(payload: any) {
    this.notificationSubject.next(payload);
  }
}
